import { captureObservabilityError } from '@psyomics/ui-common';
import { Illustration, illustrations, type IllustrationName } from '@psyomics/ui-components';
import { Link } from 'react-router-dom';

import { type ContentItemType } from './types';

type ContentItemProps = {
  readonly item: ContentItemType;
};

const FALLBACK_ILLUSTRATION = 'BrainHealth';
const isValidIllustration = (str: string): str is IllustrationName => {
  return Object.keys(illustrations).includes(str);
};

const resolveIllustration = (name: string): IllustrationName => {
  if (isValidIllustration(name)) return name;

  captureObservabilityError('Invalid illustration: ' + name);
  return FALLBACK_ILLUSTRATION;
};

const ContentItem = ({ item }: ContentItemProps) => {
  return (
    <li className="w-38">
      <Link
        className="flex flex-col h-38 w-38 items-center primary-card-link p-2 text-center text-s font-semibold leading-tight"
        to={`/content/${item.type}/${item.id}`}
      >
        <Illustration name={resolveIllustration(item.illustration)} size={64} />
        <span className="mt-2">{item.title}</span>
      </Link>
    </li>
  );
};

export { ContentItem };
